export enum CpqStep {
  CPQ_PUSH = 'CPQ_PUSH',
  DOC_PREPARATION = 'DOC_PREPARATION',
  DOC_UPLOAD = 'DOC_UPLOAD'
}
